import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_ACKNOWLEDGEMENT } from './url-constants';

type AlarmAcknowledgeEndpointSpecification = ApiEndpointSpecification;
export const AlarmAcknowledgeEndpointSpecification: AlarmAcknowledgeEndpointSpecification = {
    url: ALARM_ACKNOWLEDGEMENT,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'AlarmAcknowledgeRequestParams',
    requestBodySchemaName: 'AlarmAcknowledgeRequestBody',
    okResponseSchemaName: 'AlarmAcknowledgeOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmAcknowledge = Helpers.makeApiRequestFn<
    Types.AlarmAcknowledgeRequestParams,
    Types.AlarmAcknowledgeRequestBody,
    Types.AlarmAcknowledgeOkResponse
>(AlarmAcknowledgeEndpointSpecification);
